import {Injectable} from '@angular/core';
import {ApiClient} from './userway-api.service';
import {Observable} from 'rxjs';
import {UwV2UnitManagementDashboardAccessDetailData} from '../../../userway/sdk/UserWayApiClient';

@Injectable({
  providedIn: 'root',
})
export class UserPermissionsApiService {
  constructor(private apiClient: ApiClient) {}

  getUserPermissions(targetUserId: string): Observable<UwV2UnitManagementDashboardAccessDetailData> {
    const request = this.apiClient.api.access.uwV2UnitManagementDashboardAccessDetail(targetUserId);
    return this.apiClient.fetch(request);
  }
}
